import { render } from "./register_question_block.vue?vue&type=template&id=2fe4f900&scoped=true"
import script from "./register_question_block.vue?vue&type=script&lang=js"
export * from "./register_question_block.vue?vue&type=script&lang=js"

import "./register_question_block.vue?vue&type=style&index=0&id=2fe4f900&lang=css"
import "./register_question_block.vue?vue&type=style&index=1&id=2fe4f900&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe4f900"]])

export default __exports__